import { constantsTypes } from '../reduxConstants';

export const setShowTimeViewMode = (value) => {
  return {
    type: constantsTypes.TIME_VIEW_MODE,
    value,
  };
};
